export enum SoftCloseStatus {
    NOT_SUBMITTED = 'PENDING_SOFT_CLOSE_NOT_SUBMITTED',
    SUBMIT_SUCCESS = 'PENDING_SOFT_CLOSE_SUCCESS',
    SUBMIT_FAILURE = 'PENDING_SOFT_CLOSE_FAILURE'
}
